import {TargetBlank} from '@wandb/weave/common/util/links';
// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components';
import {Icon} from '@wandb/weave/components/Icon';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React from 'react';

export const InitiateRegstriesSetup = () => {
  return (
    <Tailwind
      style={{
        height: '100%',
        width: '100%',
      }}>
      <div className="mt-32 flex flex-col items-center">
        <div className="mb-16 flex h-80 w-80 items-center justify-center rounded-full bg-gold-300/[0.48]">
          <Icon
            name="warning"
            className="h-[33.33px] w-[33.33px] text-gold-600"
          />
        </div>
        <div className="text-2xl font-semibold">
          Registry has not been set up
        </div>
        <div className="mt-8 text-center text-lg font-normal leading-[1.575rem] text-moon-750">
          Please ask a team admin or member with edit permissions to visit this
          page to initiate setup.
        </div>
        <TargetBlank href={''}>
          <Button
            size="large"
            variant="secondary"
            className="mt-24"
            icon="documentation">
            Registry documentation
          </Button>
        </TargetBlank>
      </div>
    </Tailwind>
  );
};
